/**
 * ETag Manager
 * Handles optimistic concurrency control via ETags
 *
 * ETags are used for:
 * - PATCH requests: Include If-Match header to prevent conflicts
 * - DELETE requests: Include If-Match header to prevent accidental deletions
 * - GET responses: Store ETag for later use in mutations
 *
 * On 412 Precondition Failed:
 * - React Query automatically refetches the resource
 * - User can retry with latest ETag
 */

/** In-memory ETag cache */
const etags = new Map<string, string>()

/**
 * Generate a cache key for ETag storage
 * Format: "METHOD /path/to/resource"
 */
export function etagKey(method: string, url: string): string {
  return `${method.toUpperCase()} ${url}`
}

/**
 * Store an ETag for a resource
 */
export function rememberEtag(key: string, etag: string | null) {
  if (etag) {
    etags.set(key, etag)
  }
}

/**
 * Retrieve stored ETag for a resource
 */
export function getEtag(key: string): string | undefined {
  return etags.get(key)
}

